module.exports = __webpack_public_path__ + "static/media/exclamination.17a9b47f.png";